import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../api/generated';
import { KendoLoading } from '../../../../../components';
import { IWindowComponentProps } from '../../../../../components/windows/WindowContext';
import { IQueueListItem } from '../../../../../models/classes/IQueue';
import StqlList from '../stqlItems/StqlList';

interface IQueueEditModalProps {
    queueId: number;
    organizationInformationId: number;
    refetchQueues(): Promise<void>;
}

const validationSchema = Yup.object().shape({
    name: Yup.string().required('Šis laukas yra privalomas')
});
const QueueEditModalWindow: FC<IWindowComponentProps<IQueueEditModalProps>> = (props) => {
    const {
        componentProps: { queueId, organizationInformationId, refetchQueues },
        onClose
    } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [queue, setQueue] = useState<IQueueListItem | null>(null);
    const fetchData = async () => {
        try {
            setIsLoading(true);
            const queueResp = await api.administration.getQueue(queueId);
            if (queueResp) {
                setQueue(queueResp);
            }
        } catch (ex) {
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async (values: IQueueListItem, formikActions: formik.FormikHelpers<IQueueListItem>) => {
        try {
            setIsLoading(true);
            formikActions.setStatus();
            await api.administration.updateQueue(values);
            toast.warning('Eilė informacija sėkmingai išsaugota');

            formikActions.resetForm();
            await refetchQueues();
        } catch (ex) {
            formikActions.setStatus(ex);
            toast.error(ex.error[0]);
        } finally {
            formikActions.setSubmitting(false);
            setIsLoading(false);
            onClose();
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            {isLoading ? (
                <KendoLoading />
            ) : (
                <>
                    {queue && (
                        <formik.Formik validationSchema={validationSchema} initialValues={{ ...queue }} onSubmit={handleSubmit}>
                            {(formikProps) => (
                                <formik.Form>
                                    <div className="ms-Grid-row" dir="ltr">
                                        <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                                            <formik.Field
                                                name="name"
                                                render={({ field, form }: formik.FieldProps<string>) => (
                                                    <fabric.TextField
                                                        label="Eilės pavadinimas"
                                                        {...field}
                                                        errorMessage={
                                                            (formikProps.status && formikProps.status.name) || (form.errors.name && form.errors.name)
                                                        }
                                                    />
                                                )}
                                            />
                                        </div>
                                        <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                                            <div style={{ marginTop: '30px' }}>
                                                <formik.Field
                                                    name="isShowingInFriendlyOrganizations"
                                                    render={({ field }: formik.FieldProps<boolean>) => (
                                                        <fabric.Checkbox
                                                            label="Ar rodyti draugiškose įstaigose?"
                                                            {...field}
                                                            value={`${field.value}`}
                                                            checked={field.value}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ms-Grid-row" dir="ltr">
                                        <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                                            <div style={{ textAlign: 'right', marginTop: '30px' }}>
                                                <fabric.PrimaryButton
                                                    className="ms-slideRightIn40 ms-textAlignRight"
                                                    text="Išsaugoti"
                                                    disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
                                                    type="submit"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </formik.Form>
                            )}
                        </formik.Formik>
                    )}
                    <StqlList editableQueueId={queueId} organizationInformationId={organizationInformationId} fetchData={fetchData} />
                </>
            )}
        </>
    );
};

export default QueueEditModalWindow;
